import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChildren} from '@angular/core';
import {ToothUiManagerModel} from './tooth-ui-manager.model';
import {ToothUiManagerService} from './tooth-ui-manager.service';
import {ToothService} from '../../../../services/tooth.service';
import {Subscription} from 'rxjs';
import {ToothConfigurationModel} from '../../../../models/teeth/tooth-configuration.model';
import {ToothBaseComponent} from './tooth-base.component';
import {StaticDataService} from '../../../../services/static-data.service';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {ToothSurfaceConfigurationModel} from '../../../../models/teeth/tooth-surface-configuration.model';
import {MatCheckboxChange} from '@angular/material/checkbox';

@Component({
  selector: 'app-tooth-ui-manager',
  templateUrl: './tooth-ui-manager.component.html',
  styleUrls: ['./tooth-ui-manager.component.scss']
})
export class ToothUiManagerComponent implements AfterViewInit, OnDestroy, OnInit {
  @Input() isSingleToothMode = false;
  @Input() selectedTeeth: ToothUiManagerModel[] = [];
  @Input() isEnableSurfacePick = false;
  @Output() toothSelectionChanged = new EventEmitter<ToothUiManagerModel[]>();

  // @ts-ignore
  @ViewChildren(ToothBaseComponent) viewTeeth: QueryList<ToothBaseComponent>;

  private uiTeeth: Array<ToothUiManagerModel>;
  private teeth: ToothConfigurationModel[];

  q1: Array<ToothUiManagerModel>;

  maxillaryRight: ToothConfigurationModel[];
  maxillaryLeft: ToothConfigurationModel[];
  maxillary: ToothConfigurationModel[];
  maxillaryAnterior: ToothConfigurationModel[];
  maxillaryRightAnterior: ToothConfigurationModel[];
  maxillaryLeftAnterior: ToothConfigurationModel[];

  mandibularRight: ToothConfigurationModel[];
  mandibularLeft: ToothConfigurationModel[];
  mandibular: ToothConfigurationModel[];
  mandibularAnterior: ToothConfigurationModel[];
  mandibularRightAnterior: ToothConfigurationModel[];
  mandibularLeftAnterior: ToothConfigurationModel[];

  isReady = false;
  childLoadCount = 0;

  childViewListener: Subscription;
  surfaceEnums: EnumValidValueItemModel[] = [];

  constructor(private tpService: ToothUiManagerService,
              private toothService: ToothService,
              private staticDataService: StaticDataService) {
    this.uiTeeth = new Array<ToothUiManagerModel>();
  }

  ngOnInit() {
    if (this.staticDataService.isReady) {
      this.setupEnums();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupEnums();
        }
      });
    }

    if (this.toothService.allTeeth == null) {
      this.toothService.getAllTeeth(ToothService.enumUnitedStatesToothGrouping).subscribe((teeth) => {
        this.teeth = teeth;
        this.createGroupings();
        this.isReady = true;
        if (this.selectedTeeth.length > 0) {
          for (const st of this.selectedTeeth) {
            st.isSelected = true;
            // this.uiTeeth.push(st);
            // this.selectionChanged(st);
          }
        }
      });
    } else {
      this.teeth = this.toothService.allTeeth;
      this.createGroupings();

      if (this.selectedTeeth.length > 0) {
        for (const st of this.selectedTeeth) {
          st.isSelected = true;
          // this.uiTeeth.push(st);
          // this.selectionChanged(st);
        }
      }

      // Notify the view to show children (The teeth)
      this.isReady = true;
    }
  }

  setupEnums() {
    this.surfaceEnums = this.staticDataService.getValidValueItemsByValidValueName('enumToothSurface');
  }

  ngAfterViewInit() {
    const ivl = setInterval(() => {
      if (this.viewTeeth && this.viewTeeth.length > 0) {
        clearInterval(ivl);
        for (const t of this.viewTeeth) {
          const mod = this.selectedTeeth.find(p => p.toothModel.ToothId === t.uiModel.toothModel.ToothId);
          if (mod) {
            t.show = true;
            const iivl = setInterval(() => {
              if (this.uiTeeth && this.uiTeeth.length > 0) {
                this.selectionChanged(mod);
                clearInterval(iivl);
              }
            }, 100);
          }
        }
      }
    }, 100);
  }

  createGroupings() {
    for (let i = 0; i < 32; i++) {
      this.uiTeeth.push(new ToothUiManagerModel(false, this.teeth[i]));
    }

    this.childViewListener = this.tpService.childViewLoadedSubject.subscribe(() => {
      this.childLoadCount++;
      if (this.childLoadCount === 32) {
        this.tpService.notifyChildrenOfModelLoaded(this.uiTeeth);
      }
    });

    this.maxillaryRight = this.teeth.filter(p => p.PhysicalVorder === 1 && p.PhysicalHorderLR <= 8);
    this.maxillaryLeft = this.teeth.filter(p => p.PhysicalVorder === 1 && p.PhysicalHorderLR >= 9 && p.PhysicalHorderLR <= 16);
    this.maxillaryAnterior = this.teeth.filter(p => p.PhysicalVorder === 1 && p.PhysicalHorderLR >= 6 && p.PhysicalHorderLR <= 11);
    this.maxillaryRightAnterior = this.teeth.filter(p => p.PhysicalVorder === 1 && p.PhysicalHorderLR >= 6 && p.PhysicalHorderLR <= 8);
    this.maxillaryLeftAnterior = this.teeth.filter(p => p.PhysicalVorder === 1 && p.PhysicalHorderLR >= 9 && p.PhysicalHorderLR <= 11);
    this.maxillary = this.teeth.filter(p => p.PhysicalVorder === 1);

    this.mandibularRight = this.teeth.filter(p => p.PhysicalVorder === 2 && p.PhysicalHorderLR >= 1 && p.PhysicalHorderLR <= 8);
    this.mandibularLeft = this.teeth.filter(p => p.PhysicalVorder === 2 && p.PhysicalHorderLR >= 9 && p.PhysicalHorderLR <= 16);
    this.mandibularAnterior = this.teeth.filter(p => p.PhysicalVorder === 2 && p.PhysicalHorderLR >= 6 && p.PhysicalHorderLR <= 11);
    this.mandibularRightAnterior = this.teeth.filter(p => p.PhysicalVorder === 2 && p.PhysicalHorderLR >= 6 && p.PhysicalHorderLR <= 8);
    this.mandibularLeftAnterior = this.teeth.filter(p => p.PhysicalVorder === 2 && p.PhysicalHorderLR >= 9 && p.PhysicalHorderLR <= 11);
    this.mandibular = this.teeth.filter(p => p.PhysicalVorder === 2);
  }

  toggleSubset(subset: ToothConfigurationModel[]) {
    let includesAll = true;

    for (const model of subset) {
      const idx = this.uiTeeth.findIndex(mod => mod.toothModel.ToothId === model.ToothId && mod.isSelected);
      if (idx === -1) {
        includesAll = false;
        break;
      }
    }

    if (includesAll) {
      // Deselect if all from the subset are already selected
      for (const model of subset) {
        const idx = this.uiTeeth.findIndex(mod => mod.toothModel.ToothId === model.ToothId);
        if (idx > -1) {
          this.uiTeeth[idx].isSelected = false;
        }
      }
    } else {
      // If not all from the subset exist, select  them.
      for (const model of subset) {
        const idx = this.uiTeeth.findIndex(mod => mod.toothModel.ToothId === model.ToothId);
        if (idx > -1) {
          this.uiTeeth[idx].isSelected = true;
        }
      }
    }
    this.tpService.notifyChildrenOfGroupSelection(this.uiTeeth);
    this.toothSelectionChanged.emit(this.uiTeeth.filter(pred => pred.isSelected));
  }

  selectionChanged(model: ToothUiManagerModel) {
    const idx = this.uiTeeth.findIndex(mod => mod.toothModel.ToothId === model.toothModel.ToothId);

    if (this.isSingleToothMode) {
      for (const tooth of this.uiTeeth) {
        if (tooth.toothModel !== model.toothModel) {
          tooth.isSelected = false;
        }
      }
      this.tpService.notifyChildrenOfGroupSelection(this.uiTeeth);
    }

    if (idx > -1) {
      this.uiTeeth[idx].isSelected = model.isSelected;
    }
    const selectedTeeth = this.uiTeeth.filter(pred => pred.isSelected);
    this.toothSelectionChanged.emit(selectedTeeth);
  }

  ngOnDestroy() {
    this.childViewListener.unsubscribe();
  }

  getSurfaceFromEnum(enumToothSurfaceID: string) {
    if (this.surfaceEnums) {
      const enu = this.surfaceEnums.find(p => p.ValidValueItemId === enumToothSurfaceID);
      if (enu) {
        return enu.ItemSValue;
      }
    }
    return '';
  }

  onSurfaceChange(event: MatCheckboxChange, t: ToothUiManagerModel, surf: ToothSurfaceConfigurationModel) {
    if (event.checked) {
      t.selectedSurfaceIds.push(surf.enumToothSurfaceID);
    } else {
      const idx = t.selectedSurfaceIds.findIndex(p => p === surf.enumToothSurfaceID);
      if (idx > -1) {
        t.selectedSurfaceIds.splice(idx, 1);
      }
    }
  }
}
